exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td[data-v-ca78cbae],th[data-v-ca78cbae]{width:33%}", ""]);

// exports
